import { fetcher } from '../utils'
import { ComponentClientVO } from '@repo/types'

export default async (input: ComponentClientVO): Promise<void> => fetcher(`/api/relationship/client/new`, 'POST', input)
